import Home from './pages/Home';
import './styles/App.css';
import Footer from './components/Footer';
import Analytics from './components/Analytics';
import CookieConsent from './components/CookieConsent';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import CRMQuestionnaire from './components/CRMQuestionnaire';
import CookiePolicy from './pages/CookiePolicy';
import QuestionnaireSuccess from './components/QuestionnaireSuccess';
import RequestDemo from './pages/RequestDemo';
import DemoCRM from './pages/DemoCRM'; // Import the new component
import PrivacyPolicy from './pages/PrivacyPolicy'; // Import PrivacyPolicy component
// Import Firebase SDK
import { initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore, CACHE_SIZE_UNLIMITED } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBSODat7xiIMzxggzthc51Y3sFsga0_w1w",
  authDomain: "sophie-web-b4d97.firebaseapp.com",
  projectId: "sophie-web-b4d97",
  storageBucket: "sophie-web-b4d97.firebasestorage.app",
  messagingSenderId: "139578021831",
  appId: "1:139578021831:web:6f86b4fa8a7be34a9f2be2"
};

// Initialize Firebase
let app;
let db; // Remove the export from here

try {
  app = initializeApp(firebaseConfig);

  // Initialize Firestore with persistence
  initializeFirestore(app, {
    localCache: {
      cacheSizeBytes: CACHE_SIZE_UNLIMITED, // <-- Move here
      // This enables persistence
      persistenceSettings: {
        synchronizeTabs: true
      },
      tabManager: {
        persistenceEnabled: true
      }
    }
  });
  
  db = getFirestore(app);
} catch (error) {
  console.error("Firebase initialization error:", error);
}

// Export db here instead
export { db };

// Create a wrapper component that adds the appropriate class to Footer
function AppWithFooter() {
  const location = useLocation();
  const isDemoCRMPage = location.pathname === '/demo-crm';

  return (
    <>
      <Analytics />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/crm-questionnaire" element={<CRMQuestionnaire />} />
        <Route path="/questionnaire-success" element={<QuestionnaireSuccess />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/request-demo" element={<RequestDemo />} />
        <Route path="/demo-crm" element={<DemoCRM />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} /> {/* Add this route */}
      </Routes>
      <Footer className={isDemoCRMPage ? 'footer-demo-crm' : ''} />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppWithFooter />
    </BrowserRouter>
  );
}

export default App;